import React, { useState } from "react";
import { Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import { validationMaxLength20 } from "../../utils/formValidations";
import { AuthContainer } from "../../styles/LoginSignUp/authContainer";

interface IData {
  username: string;
}

export const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<IData>();
  const [loading, setLoading] = useState(false);
  const { setApiError } = useAuth();

  const onFinish = async (data: IData) => {
    try {
      setLoading(true);

      const res = await api.post("/accountants/forgot-password", {
        username: data.username.replace(/[_.-/-]/g, ""),
      });
      message.success(
        `O link de recuperação de senha foi enviado para o email ${res.data?.email}`,
        5
      );

      setTimeout(() => {
        setLoading(false);
        setApiError("");
        navigate("/p/login");
      }, 500);
    } catch (err: any) {
      if (err?.response?.status === 400 || err?.response?.status === 500) {
        message.error(err.response?.data?.message || "Ocorreu um erro");
      }
      setLoading(false);
      return;
    }
  };

  const handleNavigateCreateAccount = () => {
    navigate("/p/cadastrar");
  };

  const handleNavigateLogin = () => {
    navigate("/p/login");
  };

  return (
    <AuthContainer className="beauty-scrollbar">
      <div className="auth-content">
        <div className="form-container">
          <h1>Recupere sua senha</h1>
          <Form form={form} size="large" onFinish={onFinish}>
            <Form.Item name="username" rules={validationMaxLength20}>
              <Input
                placeholder="CPF/CNPJ (Apenas números) ou ID"
                maxLength={20}
              />
            </Form.Item>

            <div className="buttons">
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                className="full-width"
                loading={loading}
              >
                Recuperar
              </Button>
            </div>
            <div className="bottom-acessar">
              <Button
                type="link"
                onClick={handleNavigateLogin}
                style={{
                  fontSize: "11px",
                  width: "150px",
                }}
              >
                Voltar para o login
              </Button>
            </div>
          </Form>

          {/* <div className="footer">
            Ainda não possui uma conta?
            <Button
              type="link"
              onClick={handleNavigateCreateAccount}
              className="btn-underlined"
            >
              Cadastrar
            </Button>
          </div> */}
        </div>
      </div>
    </AuthContainer>
  );
};
